import { useState, useCallback } from 'react';

let notificationId = 0;

export const useCustomNotification = () => {
    const [notifications, setNotifications] = useState([]);

    const addNotification = useCallback((type, title, message, duration = 5000) => {
        let id = ++notificationId;

        setNotifications(prev => {
            const existing = prev.find(notification => (
                notification.type === type
                && notification.title === title
                && notification.message === message
            ));
            if (existing) {
                id = existing.id;
                return prev;
            }

            const newNotification = {
                id,
                type,
                title,
                message,
                duration
            };

            return [...prev, newNotification];
        });

        return id;
    }, []);

    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    }, []);

    const api = {
        success: (title, message, duration) => addNotification('success', title, message, duration),
        error: (title, message, duration) => addNotification('error', title, message, duration),
        warning: (title, message, duration) => addNotification('warning', title, message, duration),
        info: (title, message, duration) => addNotification('info', title, message, duration),
    };

    return {
        notifications,
        removeNotification,
        api
    };
};

export default useCustomNotification;
